module.exports = __webpack_public_path__ + "img/bg1.13cf4d5e.png";